var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-mensagem","ok-only":"","title":"Atenção!"}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.mensagem))])])}
var staticRenderFns = []

export { render, staticRenderFns }